module.exports = __webpack_public_path__ + "static/media/advertise.74556313.svg";